var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon404(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 129,
    height: 128,
    viewBox: "0 0 129 128",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #d6d7d8;\r\n      }\r\n\r\n      .cls-2 {\r\n        fill: #e90649;\r\n      }\r\n\r\n      .cls-3 {\r\n        fill: none;\r\n        stroke: #25272a;\r\n        stroke-miterlimit: 10;\r\n        stroke-width: 3px;\r\n      }\r\n    "))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_404") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icones"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 75,
    cy: 81.8,
    rx: 46.2,
    ry: 46.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 26.7,
    cy: 18.9,
    rx: 18.9,
    ry: 18.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "1.5 25.2 1.5 121.7 127.5 121.7 127.5 25.2"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 1.5,
    y: 8.4,
    width: 126,
    height: 16.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 7.8,
    y1: 16.8,
    x2: 12,
    y2: 16.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 16.2,
    y1: 16.8,
    x2: 20.4,
    y2: 16.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.6,
    y1: 16.8,
    x2: 28.8,
    y2: 16.8
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33,
    y1: 16.8,
    x2: 121.2,
    y2: 16.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.8,81.8a4.2,4.2,0,0,1-1.2,3,4.4,4.4,0,0,1-3,1.2H62.4a4.4,4.4,0,0,1-3-1.2,4.2,4.2,0,0,1-1.2-3V65a4.2,4.2,0,0,1,1.2-2.9,4.4,4.4,0,0,1,3-1.2h4.2a4.4,4.4,0,0,1,3,1.2A4.2,4.2,0,0,1,70.8,65Z"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "51.9 79.7 35.1 79.7 35.1 75.5 45.6 60.9 47.7 60.9 47.7 88.1"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "96 79.7 79.2 79.7 79.2 75.5 89.7 60.9 91.8 60.9 91.8 88.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 24.6,
    y1: 79.7,
    x2: 28.8,
    y2: 79.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 100.2,
    y1: 79.7,
    x2: 104.4,
    y2: 79.7
  }))), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.9,
    y: 33.6,
    width: 109.2,
    height: 16.79
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.9,
    y: 96.5,
    width: 109.2,
    height: 16.79
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33,
    y1: 42,
    x2: 45.6,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 49.8,
    y1: 42,
    x2: 62.4,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 66.6,
    y1: 42,
    x2: 79.2,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 83.4,
    y1: 42,
    x2: 96,
    y2: 42
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 33,
    y1: 104.9,
    x2: 96,
    y2: 104.9
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon404);
export default __webpack_public_path__ + "static/media/icon_404.06a74054da7783a7469b9588668fa7c7.svg";
export { ForwardRef as ReactComponent };